import React, { Component } from 'react'
import { Link } from 'react-router'
import { A, Icon } from '@driftt/tide-core-legacy'

export default class IntegrationBreadcrumb extends Component {
  static defaultProps = {
    backLinkText: '',
    backLinkUrl: ''
  }

  render() {
    const { backLinkText, backLinkUrl } = this.props
    return (
        <div className="integration-back">
            <A href={backLinkUrl}>
            <Icon className="down-arrow" width={15} height={10} name="arrow-1-left"/>
            {backLinkText}
            </A>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/IntegrationBreadcrumb.js